import * as React from 'react';

import CalendarFiltersCourseType from './calendar-filters-course-type';
import CalendarFiltersEventType from './calendar-filters-event-type';
import CalendarFiltersInstructor from './calendar-filters-instructor';
import CalendarFiltersMonth from './calendar-filters-month';
import CalendarFiltersPrice from './calendar-filters-price';
import CalendarFiltersFormat from './calendar-filters-format';
import CalendarFiltersLocation from './calendar-filters-location';


interface ICalendarFilters {
    selectedMonthFilter: string;
    selectedCourseTypeFilter: Array<string>;
    selectedEventTypeFilter: Array<string>;
    selectedInstructorFilter: string;
    selectedFormatFilter: Array<string>;
    selectedPriceFilter: boolean;
    selectedLocationFilter: string;
}

class CalendarFilters extends React.Component<ICalendarFilters, any>{
    //
    render() {
        return (
            <div className="calendar-filters">
                <CalendarFiltersCourseType selectedCourseTypeFilter={this.props.selectedCourseTypeFilter} />
                <CalendarFiltersEventType selectedEventTypeFilter={this.props.selectedEventTypeFilter} />
                <CalendarFiltersInstructor selectedInstructorFilter={this.props.selectedInstructorFilter} />
                <CalendarFiltersMonth selectedMonthFilter={this.props.selectedMonthFilter} />
                <CalendarFiltersPrice selectedPriceFilter={this.props.selectedPriceFilter} />
                <CalendarFiltersFormat selectedFormatFilter={this.props.selectedFormatFilter} />
                <CalendarFiltersLocation selectedLocationFilter={this.props.selectedLocationFilter} />

                <div className="calendar-filters-section">
                </div>
                <div className="calendar-filters-section">
                </div>
            </div>
        )
    }
};

export default CalendarFilters;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/filters/calendar-filters.tsx